/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdWebFeaturesPlayGameUnityGameConfigOptions } from './FxIdWebFeaturesPlayGameUnityGameConfigOptions';
import {
    instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions,
    FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSON,
    FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped,
    FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSON,
} from './FxIdWebFeaturesPlayGameUnityGameConfigOptions';

/**
 * @type FxIdWebFeaturesPlayGameResponseUnityGameConfig
 * 
 * @export
 */
export type FxIdWebFeaturesPlayGameResponseUnityGameConfig = FxIdWebFeaturesPlayGameUnityGameConfigOptions;

export function FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSON(json: any): FxIdWebFeaturesPlayGameResponseUnityGameConfig {
    return FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponseUnityGameConfig {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions(json)) {
        return FxIdWebFeaturesPlayGameUnityGameConfigOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSONTyped(value?: FxIdWebFeaturesPlayGameResponseUnityGameConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdWebFeaturesPlayGameUnityGameConfigOptions(value)) {
        return FxIdWebFeaturesPlayGameUnityGameConfigOptionsToJSON(value as FxIdWebFeaturesPlayGameUnityGameConfigOptions);
    }

    return {};
}

